import { AppShell } from "@/components/AppShell";
import { AUSWERTUNGEN_SECTION_SUBTITLES } from "@/lib/auswertungenNav";
import { FestpreisHoursReport } from "@/pages/auswertungen/FestpreisHoursReport";

export function FestpreisHoursPage() {
  return (
    <AppShell
      title="Auswertungen"
      subtitle={AUSWERTUNGEN_SECTION_SUBTITLES["festpreis-hours"]}
    >
      <FestpreisHoursReport />
    </AppShell>
  );
}
